Directives.ProjectToolsDirective = function ProjectToolsDirective() {

    // @ngInject
    function ProjectToolsDirectiveControllerFunc($scope, $injector, $transclude, WorkspaceService, UsersManager) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'ProjectToolsDirectiveController';
        this.$transclude = $transclude;
        this.WorkspaceService = WorkspaceService;
        this.user = UsersManager.getCurrUser();
    }

    var ProjectToolsDirectiveController = Class(Controllers.BaseController, {
        constructor: ProjectToolsDirectiveControllerFunc,

        isSlotFilled: function isSlotFilled(name) {
            return this.$transclude.isSlotFilled(name);
        }
    });

    return {
        scope: {
            showMoreTools: '='
        },
        transclude: {
            'header': '?toolsHeader',
            'pipeline': "?pipelineComponent",
            'team': '?addTeamMembersComponent',
            'tasks': '?tasksComponent',
            'showmore' : '?moreOptions',
            'workflow': '?workflowComponent',
            'notes': '?notes',
            'projects': '?relatedProjectsComponent',
            'leadSource': '?leadSourceComponent',
            'timeTracker': '?timeTrackerComponent',
            'scheduledSessions': '?scheduledSessionsComponent'
        },
        templateUrl: 'angular/app/modules/core/features/workspace/project_tools/project_tools_directive_template.html',
        controller: ProjectToolsDirectiveController,
        controllerAs: 'projectToolsVm',
        bindToController: true
    };
};
